var _path, _path2, _path3, _path4, _path5;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgSelected(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 41,
    viewBox: "0 0 40 41",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M33.5251 32.6194L34.0251 32.6194L34.0251 32.1194L34.0251 5.38013C34.0251 2.89485 32.0104 0.880128 29.5251 0.880128L9.15039 0.880127C6.66511 0.880127 4.65039 2.89485 4.65039 5.38013L4.65039 32.1194L4.65039 32.6194L5.15039 32.6194L33.5251 32.6194Z",
    fill: "#4285F4",
    stroke: "#F3F3F3"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M2.46045 20.9826C2.46045 19.2793 3.8413 17.8984 5.54466 17.8984C7.24802 17.8984 8.62887 19.2793 8.62887 20.9826L8.62887 36.6093L6.46045 36.6093C4.25131 36.6093 2.46045 34.8184 2.46045 32.6093L2.46045 20.9826Z",
    fill: "#4285F4",
    stroke: "#F3F3F3",
    strokeWidth: 3
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M31.5312 19.5581C31.5312 17.8547 32.9121 16.4739 34.6155 16.4739C36.3188 16.4739 37.6997 17.8547 37.6997 19.5581L37.6997 31.1847C37.6997 33.3939 35.9088 35.1847 33.6997 35.1847L31.5312 35.1847L31.5312 19.5581Z",
    fill: "#4285F4",
    stroke: "#F3F3F3",
    strokeWidth: 3
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M38.4595 31.1564L38.4595 35.4426C38.4595 37.6518 36.6686 39.4426 34.4595 39.4426L6.00001 39.4426C3.79087 39.4426 2.00001 37.6518 2.00001 35.4426L2.00001 31.1564L38.4595 31.1564Z",
    fill: "#4285F4",
    stroke: "#F3F3F3",
    strokeWidth: 3
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M15.6138 12.869L18.1137 15.369L23.1137 10.369",
    stroke: "#F3F3F3",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgSelected);
export default __webpack_public_path__ + "static/media/selected.b15c1d0b98468f9751c583015e187b98.svg";
export { ForwardRef as ReactComponent };